import clsx from 'clsx';
import { useWatch } from 'react-hook-form';
import { PASSWORD_RULES, STRENGTH_LEVELS, SPECIAL_CHAR_REGEX } from './constants';
import styles from './passwordForm.module.scss';
import { CheckOutlined } from '@ant-design/icons';

const SPECIAL_CHAR_REGEX_GLOBAL = new RegExp(SPECIAL_CHAR_REGEX.source, 'g');

const PasswordStrengthIndicator: React.FC = () => {
  const password: string = useWatch({ name: 'password' }) ?? '';
  if (!password) return null;

  const ruleResults = PASSWORD_RULES.map((rule) => rule.test(password));
  const allMet = ruleResults.every(Boolean);
  const len = password.length;
  const multiUpper = (password.match(/[A-Z]/g) ?? []).length >= 2;
  const multiSpecial = (password.match(SPECIAL_CHAR_REGEX_GLOBAL) ?? []).length >= 2;

  const level = !allMet
    ? STRENGTH_LEVELS[0]
    : len >= 14 || (multiUpper && multiSpecial && len >= 11)
      ? STRENGTH_LEVELS[3]
      : len >= 11
        ? STRENGTH_LEVELS[2]
        : STRENGTH_LEVELS[1];

  return (
    <div className={styles.strengthContainer}>
      <div className={styles.strengthHeader}>
        <span>Password strength</span>
        <span className={clsx(styles.strengthLabel, styles[level.key])}>{level.label}</span>
      </div>
      <div className={styles.strengthTrack}>
        <div className={clsx(styles.strengthBar, styles[level.key])} />
      </div>
      <ul className={styles.rulesList}>
        {PASSWORD_RULES.map((rule, i) => (
          <li key={rule.label} className={ruleResults[i] ? styles.ruleMet : styles.ruleUnmet}>
            <span>{ruleResults[i] ? <CheckOutlined /> : '○'}</span>
            {rule.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordStrengthIndicator;
